import type { SVGProps } from 'react';

const SvgClassSuppoter = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z'
      fill='#3146BB'
    />
    <g clipPath='url(#clip0_1234_40758)'>
      <path
        d='M17.997 9.87249V9.23249C17.997 6.70211 15.9348 4.63989 13.3985 4.63989H10.5956C8.06519 4.63989 6.00296 6.70211 6.00296 9.23249V9.87249C4.87111 10.0384 4 10.8917 4 11.9288V13.2977C4 14.4532 5.07259 15.3895 6.39407 15.3895C6.45333 15.3895 6.50667 15.3895 6.56593 15.3777C7.12889 16.4147 8.07704 17.2147 9.22667 17.5762C9.21481 17.6473 9.20296 17.7184 9.20296 17.7954C9.20296 18.6725 9.92 19.3895 10.797 19.3895H13.6C14.477 19.3895 15.1941 18.6725 15.1941 17.7954C15.1941 16.9184 14.477 16.2014 13.6 16.2014H10.797C10.4474 16.2014 10.1274 16.3199 9.86667 16.5095C8.32593 16.1717 7.18815 14.7969 7.18815 13.1969V9.23249C7.18815 7.35397 8.71704 5.82508 10.6015 5.82508H13.4044C15.283 5.82508 16.8178 7.35397 16.8178 9.23249V14.7969C16.8178 15.1229 17.0844 15.3895 17.4104 15.3895C17.4281 15.3895 17.44 15.3836 17.4578 15.3777C17.5111 15.3777 17.5704 15.3895 17.6119 15.3895C18.9333 15.3895 20.0059 14.4532 20.0059 13.2977V11.9288C20.0059 10.8917 19.1348 10.0384 18.003 9.87249H17.997Z'
        fill='#fff'
      />
    </g>
    <defs>
      <clipPath id='clip0_1234_40758'>
        <rect width={16} height={14.7496} fill='#fff' transform='translate(4 4.63989)' />
      </clipPath>
    </defs>
  </svg>
);
export default SvgClassSuppoter;
